import {
  CustomErrorVariant,
  CustomErrorVariantDetails
} from '../models/custom-error.models';

export const CustomErrorVariantDetailsMocks: CustomErrorVariantDetails = {
  errorCode: '702',
  errorMessage: "Content Doesn't Exists"
};

export const CustomErrorVariantMocks: CustomErrorVariant = {
  format: 'json',
  error: CustomErrorVariantDetailsMocks
};
